/* eslint-disable no-unused-vars */
import { MultipleCompanyDataParams } from "@lhd/features/UserCompanies/CompanyDetail/GeneralInfo/Information/hook";
import { Date } from ".";

export type WorkColumns = Date & {
  id: number;
  company_id: number;
  sort_index: number;
  title: string;
  unit?: string;
  unit_type?: "day" | "time";
  math_type?: string;
  work_column_values: Date &
    {
      id: number;
      value: number;
      work_column_id: number;
      work_id: number;
    }[];
};

export enum ContractStatusEnums {
  TRIAL = "trial",
  OFFICIAL = "official",
  NOT_SIGNED = "not_signed",
  UN_CONTRACTED = "un_contracted",
  NEW_CONTRACT = "new_contract",
  CANCELLED = "cancelled",
  CONTRACT_TERMINATED = "contract_terminated",
  SUSPENDED = "suspended",
  PENDING = "pending",
}

export type Company = Date & {
  ceo_name: string;
  co_number: string;
  id: number;
  is_admin: boolean;
  manage_code: number;
  name_kana: string;
  station_id: number;
  name: string;
  parent_id: number;
  address: string;
  zipcode: string;
  control_number: string;
  sub_companies: Company[];
  work_columns: WorkColumns[];
  is_work_default: boolean;
  logo_original_url: string;
  stamp_icon_medium_thumb_url: string;
  industry_category_id?: number;
  industry_category?: IndustryCategories;
  industry_category_tax_val?: number;
  is_root_company: boolean;
  creator_id: number | null;
  contract_status?: ContractStatusEnums;
  creator_full_name?: string;
  user_is_admin?: boolean;
  payment_not_required?: boolean;
};

export type IndustryCategories = {
  id: number;
  name: string;
  insurance_tax: number;
};

export type CompanyType = {
  label: string;
  value: string;
};

//tab2
export type UserSystem = {
  id: number;
  full_name: string;
};
export type CompanyInvoiceInput = {
  company_id?: number;
  invoice_no: string;
  start_date: Date;
  registration_date: Date;
};

export type CompanyInvoice = Date & {
  id?: string | number;
  company_id: number;
  invoice_no: string;
  start_date: Date;
  registration_date: Date;
  updated_by: UserSystem;
  created_by: UserSystem;
};
export type BankInfoInput = {
  bank?: {
    id?: string;
    name?: string;
    branch: string;
    bank_type: string;
    bank_number: string;
    trade_name: string;
    address: string;
  };
  start_date: string;
  end_date: string;
};
export type BankInfo = Date &
  BankInfoInput & {
    id: string;
    company_id: number;
    updated_by: UserSystem;
    updated_by_id: number;
  };

export type AccountingPeriodInput = {
  period?: string;
  assigned_accountant?: string;
  assigned_labor_consultant?: string;
  start_date?: string;
  end_date?: string;
  financial_report_deadline?: string;
  foundation_establishment_label?: string;
};
export type AccountingPeriod = Date &
  AccountingPeriodInput & {
    id: string;
    company_id: number;
    default_start_date?: string | null;
    foundation_establishment_type?: "foundation" | "establishment";
    end_date_editable?: boolean;
    staff_editable?: boolean;
    updated_by: UserSystem;
  };
export type TaxInfoInput = {
  industry_category_id: number;
  apply_date: string;
  sort_index?: string | null;
};

export type TaxInfo = Date & {
  id: number;
  company_id: number;
  industry_category_id: number;
  industry_category_tax_val: number;
  apply_date: string;
  end_date: string | null;
  sort_index: number | null;
  created_by: number;
  updated_by: number;
  industry_category: IndustryCategories;
};
export type CompanyRegistrationInfoInput = {
  registration_name?: string;
  registration_code?: string;
  branch_code?: string;
  involved_professional?: string;
  note?: string;
  start_date?: string;
  end_date?: string;
};
export type CompanyRegistrationInfo = CompanyRegistrationInfoInput & {
  id: number;
  company_id: number;
  updated_by: UserSystem;
  created_at?: string;
  updated_at?: string;
};

export type CompanyPhoneNumberInput = {
  location_type?: "head_office" | "branch_office" | "sales_office";
  location_name?: string;
  fax?: string;
  usage_memo?: string;
  contract_memo?: string;
  start_date?: string;
  end_date?: string;
};

export type CompanyPhoneNumber = CompanyPhoneNumberInput & {
  id: number;
  company_id: number;
  updated_by: UserSystem;
  created_at?: string;
  updated_at?: string;
};

export type CompanyFinancialStatementCreateInput = {
  financial_statement_name: string;
  description?: string;
  sort_index?: number;
  files?: { file: File; period: string }[];
};
export type CompanyFinancialStatementUpdateInput =
  CompanyFinancialStatementCreateInput & {
    file_deleted_ids?: string[];
  };
export type CompanyFinancialStatement = {
  id: number;
  company_id: number;
  financial_statement_name: string;
  description: string;
  sort_index: number;
  files: { file: File; period: string }[];
  documents: {
    id: number;
    document_name: string;
    document_url: string;
    document_type: string;
    document_size: number;
    document_created_at: string;
  }[];
  created_by: UserSystem;
  updated_by: UserSystem;
  created_at: string;
  updated_at: string;
};
//tab3
export type CompanyRegulartion = {
  id: number;
  company_id: number;
  regulation_name: string;
  description: string;
  sort_index: number;
  files: { file: File; period: string }[];
  documents: {
    id: number;
    document_name: string;
    document_url: string;
    document_type: string;
    document_size: number;
    document_created_at: string;
  }[];
  created_by: UserSystem;
  updated_by: UserSystem;
  created_at: string;
  updated_at: string;
};
export type CompanyRegulartionCreateInput = Pick<
  CompanyRegulartion,
  "regulation_name" | "description" | "files"
>;

export type CompanyRegulartionUpdateInput = CompanyRegulartionCreateInput & {
  file_deleted_ids?: string[];
};

export type ShareRecordValue = {
  id: number;
  name: string;
  share_values: {
    ownership_type: string;
    share_type: string;
  }[];
};
export type CompanyShareRecord = {
  app_record_ids: string[];
  values: ShareRecordValue[];
};
export type MultipleCompanyDataInput = {
  paginations: MultipleCompanyDataParams;
  companyId?: string;
};

export type WorkerApplicationUsage = {
  appraisal: boolean;
  basic_features: boolean;
  salary_management: boolean;
  company_policy: boolean;
  project_management: boolean;
  e_learning: boolean;
  actual_kpi: boolean;
  role_permission: boolean;
};
